import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';

const API_URL = process.env.REACT_APP_API_URL;

export default function ViewGuestPosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getIdToken } = useAuth();

  useEffect(() => {
    const token = getIdToken();
    axios.get(`${API_URL}/api/articles/mine.json`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => { setPosts(res.data.articles || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [getIdToken]);

  if (loading) return <div style={s.loading}>Loading...</div>;

  return (
    <div>
      <div style={s.topBar}>
        <h2 style={s.pageTitle}>My Guest Posts</h2>
        <Link to="/dashboard/guest-post/add" style={s.addBtn}>+ New Guest Post</Link>
      </div>

      {posts.length === 0 ? (
        <div style={s.empty}>
          <p>No guest posts yet.</p>
          <Link to="/dashboard/guest-post/add" style={s.primaryBtn}>Submit your first guest post</Link>
        </div>
      ) : (
        <div style={s.card}>
          <div style={s.tableHead}><span>Title</span><span>Status</span><span>Date</span><span></span></div>
          {posts.map((p) => (
            <div key={p.id} style={s.tableRow}>
              <span style={s.title}>{p.title}</span>
              <span style={{ ...s.badge, ...(p.published ? s.published : s.draft) }}>
                {p.published ? 'Published' : 'Draft'}
              </span>
              <span style={s.date}>{fmtDate(p.createdAt)}</span>
              <Link to={`/article/${p.id}`} style={s.viewLink}>View →</Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

const s = {
  topBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1.5rem' },
  pageTitle: { margin: 0, fontSize: '1.4rem', fontWeight: 700, color: '#1a1a2e' },
  addBtn: { padding: '0.5rem 1.1rem', background: '#1565c0', color: '#fff', borderRadius: 6, textDecoration: 'none', fontSize: '0.875rem', fontWeight: 600 },
  primaryBtn: { display: 'inline-block', padding: '0.6rem 1.2rem', background: '#1565c0', color: '#fff', borderRadius: 6, textDecoration: 'none', fontSize: '0.875rem', fontWeight: 600 },
  loading: { textAlign: 'center', padding: '3rem', color: '#888' },
  empty: { textAlign: 'center', padding: '3rem', color: '#888', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' },
  card: { background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', overflow: 'hidden' },
  tableHead: { display: 'grid', gridTemplateColumns: '1fr 130px 140px 70px', padding: '0.7rem 1.25rem', background: '#f8f8f8', fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', color: '#999', borderBottom: '1px solid #eee' },
  tableRow: { display: 'grid', gridTemplateColumns: '1fr 130px 140px 70px', padding: '0.9rem 1.25rem', borderBottom: '1px solid #f0f0f0', alignItems: 'center' },
  title: { fontWeight: 600, fontSize: '0.875rem', color: '#1a1a2e', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', paddingRight: '0.5rem' },
  badge: { fontSize: '0.75rem', fontWeight: 600, padding: '0.2rem 0.55rem', borderRadius: 20, display: 'inline-block' },
  published: { background: '#dcfce7', color: '#15803d' },
  draft: { background: '#f3f4f6', color: '#6b7280' },
  date: { fontSize: '0.8rem', color: '#888' },
  viewLink: { color: '#1565c0', textDecoration: 'none', fontSize: '0.82rem', fontWeight: 600 },
};
